import { Spacing } from '@lichtblick/theme/constants/spacing';
// CMS spacings need to be mapped to the spacings from the theme
const spacingMap = {
    none: 0,
    xxs: Spacing.Xxs,
    xs: Spacing.Xs,
    s: Spacing.S,
    m: Spacing.M,
    l: Spacing.L,
    xl: Spacing.Xl,
    xxl: Spacing.Xxl,
    '3xl': Spacing['3Xl']
};
export const getSpacing = (spacing)=>spacing ? spacingMap[spacing] : undefined;

//# sourceMappingURL=spacing.js.map